// extracted by mini-css-extract-plugin
var _1 = "t2tn";
var _2 = "t2to";
export { _1 as "empty", _2 as "fill" }
